<template>
  <v-menu offset-x class="elevation-0" :close-on-content-click="false">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        rounded
        x-large
        text
        v-bind="attrs"
        v-on="on"
        @click="dialog = true"
        v-show="sigfloMessages != null && sigfloMessages.length > 0"
      >
        <div class="sigfloButtonSmall300 black--text text-capitalize" v-if="logoSide == 'right'">Need Help?</div>
        <div class="sigHelpLogo">
          <v-img src="@/assets/images/sigfloSymbolPurple.svg" width="32" height="34" class="mx-3"></v-img>
        </div>
        <div class="sigfloButtonSmall300 black--text text-capitalize" v-if="logoSide == 'left'">Need Help?</div>
      </v-btn>
    </template>
    <sig-help-menu :sigfloMessages="sigfloMessages" />
  </v-menu>
</template>

<script>
  import { mapState } from 'vuex';
  import sigHelpMenu from './SigHelpMenu.vue';

  export default {
    components: {
      sigHelpMenu
    },
    props: {
      logoSide: {
        type: String,
        default: 'right'
      },
      sigfloMessages: {
        type: Array,
        required: true
      }
    },
    data() {
      return {
        dialogModel: false
      };
    },
    computed: {
      ...mapState(['configurator'])
    }
  };
</script>

<style scoped></style>
